import React from 'react';
import styled, { css } from 'styled-components';

const SplashContainer = styled.div<{ $fullWidth?: boolean }>`
  height: 100vh;
  width: 100%;
  background: #000000;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  position: relative;
  
  /* Desktop layout */
  @media (min-width: 768px) {
    ${props => props.$fullWidth ? css`
      max-width: 720px;
      width: 100%;
      margin: 0 auto;
      border-radius: 24px;
      border: 1px solid rgba(255, 255, 255, 0.08);
      background: #0b0b12;
    ` : css`
      max-width: 414px;
      width: 414px;
      margin: 0 auto;
      box-shadow: 0 0 40px rgba(0, 0, 0, 0.8), 
                  0 0 0 12px rgba(0, 0, 0, 0.5),
                  0 0 0 16px #333333;
      border-radius: 24px;
      left: 50%;
      transform: translateX(-50%);
      position: relative;
      z-index: 1;
    `}
  }
`;

const LoaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;

const PreloaderLogo = styled.img`
  width: 120px;
  height: 120px;
  object-fit: contain;
  animation: logoMove 1.9s cubic-bezier(0.7, 0.2, 0.2, 1) forwards;

  @keyframes logoMove {
    0% {
      transform: translateY(80px);
      opacity: 0;
    }
    20% {
      transform: translateY(0);
      opacity: 1;
    }
    70% {
      transform: translateY(0);
      opacity: 1;
    }
    100% {
      transform: translateY(-80px);
      opacity: 0;
    }
  }
`;

interface SentrySplashScreenProps {
  fullWidth?: boolean;
}

const SentrySplashScreen: React.FC<SentrySplashScreenProps> = ({ fullWidth = false }) => {
  return (
    <SplashContainer $fullWidth={fullWidth}>
      <LoaderWrapper>
        <PreloaderLogo
          src="/Sentry-Gold-Gradient.svg"
          alt="Sentry Gold Gradient"
        />
      </LoaderWrapper>
    </SplashContainer>
  );
};

export default SentrySplashScreen;
